import React, { useEffect, useState } from 'react'
import { Stack } from '@mui/system'
import { Link, IconButton, Box } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useStore } from 'effector-react'
import {
  $permissions,
  $permissionsStatus,
  $roles,
  createRoleFx,
  getPermissionsFx,
  getRolesFx,
  updateRoleFx
} from '../../Api/permissions'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import {
  deletePermissionFx,
  revokePermissionFx
} from '../../Api/editPermissions'
import { FormProvider, useForm } from 'react-hook-form'
import AutocompleteSearch from '../../components/AutocompleteSearch'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

export default function PermissionsWidget() {
  const [grantModal, setGrantModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [createModal, setCreateModal] = useState(false)
  const [roleId, setRoleId] = useState(0)

  const permissions = useStore($permissions)
  const roles = useStore($roles)
  console.log('roles - ', roles)

  const permissionsStatus = useStore($permissionsStatus)
  const formMethodsGrant = useForm({
    defaultValues: {
      userId: 0
    }
  })

  const formMethodsEdit = useForm({
    defaultValues: {
      id: 0,
      key: '',
      name: '',
      permissionIds: []
    }
  })

  const formMethodsCreate = useForm({
    defaultValues: {
      key: '',
      name: '',
      permissionIds: []
    }
  })

  const registerEditForm = formMethodsEdit.register
  const registerCreateForm = formMethodsCreate.register

  const handleSubmitGrant = formMethodsGrant.handleSubmit
  const handleSubmitEdit = formMethodsEdit.handleSubmit
  const handleCreateSubmit = formMethodsCreate.handleSubmit
  const setEditFormValue = formMethodsEdit.setValue

  const resetCreateForm = formMethodsCreate.reset

  const toggleGrantModal = () => setGrantModal(!grantModal)
  const toggleEditModal = () => setEditModal(!editModal)
  const toggleCreateModal = () => setCreateModal(!createModal)

  const handleGrant = (event, roleId) => {
    event.stopPropagation()

    setRoleId(roleId)
    toggleGrantModal()
  }

  const handleDelete = (event, roleId) => {
    event.stopPropagation()

    deletePermissionFx({ roleId })
  }

  const handleRevoke = (event, roleId, userId) => {
    event.stopPropagation()

    revokePermissionFx({ userId, roleId, type: 'revoke' })
  }

  const handlePermissionsEdit = (event, roleId) => {
    event.stopPropagation()
    setRoleId(roleId)

    toggleEditModal()
  }

  const onSubmit = ({ userId }) => {
    const selectedRoleId =
      roles.find((item) => {
        if (item.id === roleId) {
          return item
        }
        return undefined
      })?.id || 0

    toggleGrantModal()
    revokePermissionFx({ userId, roleId: selectedRoleId, type: 'grant' })
  }

  const onEditSubmit = (data) => {
    data.id = roleId
    toggleEditModal()
    updateRoleFx({
      ...data,
      key: `${data.name}`
    })
    updateRoleFx(data)
  }

  const onCreateSubmit = (data) => {
    toggleCreateModal()
    data.key = `${data.name}`
    createRoleFx(data)
    resetCreateForm()
  }

  useEffect(() => {
    getRolesFx()
    getPermissionsFx()
  }, [])

  useEffect(() => {
    if (permissionsStatus === 'shouldUpdate') {
      getRolesFx()
    }
  }, [permissionsStatus])

  console.log('roles - ', roles)

  useEffect(() => {
    setEditFormValue('key', roles.find((role) => role.id === roleId)?.key || '')
    setEditFormValue(
      'name',
      roles.find((role) => role.id === roleId)?.name || ''
    )
  }, [roleId, roles, setEditFormValue])

  return (
    <Paper sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }} elevation={0}>
      <BlockTitle backUrl="/settings" label="Настройки" />
      <Stack marginTop="20px" spacing="16px" maxWidth="870px">
        <Stack alignItems="flex-start">
          <Button variant="contained" size="small" onClick={toggleCreateModal}>
            + Добавить роль
          </Button>
        </Stack>
        {roles?.map((role) => (
          <Accordion key={role.description}>
            <AccordionSummary>
              <Stack
                direction="row"
                width="100%"
                justifyContent="space-between"
              >
                <Typography variant="subtitle1" fontWeight="600">
                  {role.name}
                </Typography>
                <Stack direction="row" spacing="10px">
                  <Button
                    size="small"
                    variant="contained"
                    onClick={(event) => handlePermissionsEdit(event, role?.id)}
                  >
                    Редактировать
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={(event) => handleGrant(event, role?.id)}
                  >
                    Добавить пользователя
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    onClick={(event) => handleDelete(event, role?.id)}
                  >
                    Удалить
                  </Button>
                </Stack>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Divider />
              <Table>
                <TableHead>
                  <TableCell>Имя</TableCell>
                  <TableCell align="right">Действия</TableCell>
                </TableHead>
                <TableBody>
                  {role.users?.length === 0 && (
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2" color="ActiveBorder">
                          Пользователи с такой ролью не найдены
                        </Typography>
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  )}

                  {role?.users?.map((user) => (
                    <TableRow key={user.name}>
                      <TableCell>
                        <Typography variant="subtitle2">{user.name}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          size="small"
                          color="error"
                          variant="contained"
                          onClick={(event) =>
                            handleRevoke(event, role?.id, user?.id)
                          }
                        >
                          Удалить
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        ))}
        <Modal open={grantModal} onClose={toggleGrantModal}>
          <Paper
            sx={{
              padding: '20px',
              width: '365px',
              transform: 'translate(-50%, -50%)',
              position: 'absolute',
              left: '50%',
              top: '50%',
              overflow: 'scroll'
            }}
          >
            <FormProvider {...formMethodsGrant}>
              <form onSubmit={handleSubmitGrant(onSubmit)}>
                <Stack spacing="20px">
                  <AutocompleteSearch
                    sx={{ width: '325px' }}
                    title="Выдать права"
                    name="userId"
                    url="user/search"
                    isOnlyId
                    defaultValue={null}
                    required
                  />
                  <Typography variant="caption">
                    Введите имя пользователя, которому хотите выдать права типа{' '}
                    <Typography variant="caption" color="red">
                      `{roles.find((role) => role.id === roleId)?.name}`
                    </Typography>
                  </Typography>
                  <Button variant="contained" color="success" type="submit">
                    Выдать права
                  </Button>
                </Stack>
              </form>
            </FormProvider>
          </Paper>
        </Modal>
        <Modal open={editModal} onClose={toggleEditModal}>
          <Paper
            sx={{
              padding: '20px',
              width: '570px',
              transform: 'translate(-50%, -50%)',
              position: 'absolute',
              left: '50%',
              top: '50%',
              height: '80vh',
              overflow: 'scroll'
            }}
          >
            <FormProvider {...formMethodsEdit}>
              <form onSubmit={handleSubmitEdit(onEditSubmit)}>
                <Stack spacing="20px">
                  <Typography variant="h5">Редактирование роли</Typography>
                  <TextField
                    value={roleId}
                    label="id"
                    size="small"
                    {...registerEditForm('id')}
                    type="hidden"
                    sx={{ display: 'none' }}
                  />
                  <TextField
                    variant="standard"
                    label="Название"
                    size="small"
                    {...registerEditForm('name')}
                  />
                  <Stack alignItems="flex-start">
                    {permissions?.map((permission) => {
                      const selectedRole = roles.find(
                        (role) => role.id === roleId
                      )
                      const rolePermissions = selectedRole?.permissions?.reduce(
                        (prev, curr) => {
                          return [...prev, curr?.id]
                        },
                        []
                      )

                      const defaultChecked = rolePermissions?.includes(
                        permission?.id
                      )

                      return (
                        <FormControlLabel
                          key={permission.key}
                          control={
                            <Checkbox
                              size="small"
                              {...registerEditForm(`permissionIds`)}
                              defaultChecked={defaultChecked}
                              value={permission.id}
                            />
                          }
                          label={permission.name}
                        />
                      )
                    })}
                  </Stack>
                  <Stack alignItems="flex-start" spacing="20px" direction="row">
                    <Button variant="outlined" onClick={toggleEditModal}>
                      Отмена
                    </Button>
                    <Button variant="contained" type="submit">
                      Сохранить
                    </Button>
                  </Stack>
                </Stack>
              </form>
            </FormProvider>
          </Paper>
        </Modal>
        <Modal open={createModal} onClose={toggleCreateModal}>
          <Paper
            sx={{
              padding: '20px',
              width: '570px',
              transform: 'translate(-50%, -50%)',
              position: 'absolute',
              left: '50%',
              top: '50%',
              height: '80vh',
              overflow: 'scroll'
            }}
          >
            <FormProvider {...formMethodsCreate}>
              <form onSubmit={handleCreateSubmit(onCreateSubmit)}>
                <Stack spacing="20px">
                  <Typography variant="h5">Создание роли</Typography>
                  <TextField
                    variant="standard"
                    label="Название"
                    size="small"
                    {...registerCreateForm('name')}
                  />
                  <Stack alignItems="flex-start">
                    {permissions?.map((permission) => (
                      <FormControlLabel
                        key={permission.key}
                        control={
                          <Checkbox
                            size="small"
                            {...registerCreateForm(`permissionIds`)}
                            value={permission.id}
                          />
                        }
                        label={permission.name}
                      />
                    ))}
                  </Stack>
                  <Stack alignItems="flex-start" spacing="20px" direction="row">
                    <Button variant="outlined" onClick={toggleCreateModal}>
                      Отмена
                    </Button>
                    <Button variant="contained" type="submit">
                      Сохранить
                    </Button>
                  </Stack>
                </Stack>
              </form>
            </FormProvider>
          </Paper>
        </Modal>
      </Stack>
    </Paper>
  )
}
